import * as o from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/ArrowsSplit.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(s, { ref: e, ...t, weights: a }));
r.displayName = "ArrowsSplitIcon";
const p = r;
export {
  p as ArrowsSplit,
  r as ArrowsSplitIcon
};
